$ = require 'jquery'
{ map } = require 'lodash'

module.exports =
class workflowSequence

  constructor: ->
    @$section   = $ '.section-workflow'
    @$heading   = @$section.find '.heading img'
    @$text      = @$section.find '.text'
    @$img       = @$section.find '.img-1'
    @$list      = @$section.find '.flow-list li'
    @$listFrame = @$list.find '.frame'
    @$listText  = @$list.find '.text-image'

  getInitialVals: =>
    [
      {
        e: [ @$heading, @$img ]
        p: { display: 'none' }
      }
      {
        e: [ @$text, @$listFrame, @$listText ]
        p: { visibility: 'hidden' }
      }
    ]

  getSequences: =>
    listSequences = map @$list, (el, i) =>
      [
        {
          e: @$listFrame.eq i
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutCubic', -200 ]
          o: { duration: 300, visibility: 'visible', delay: 600 + (200 * i) }
        }
        {
          e: @$listText.eq i
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutCubic', -200 ]
          o: { duration: 300, visibility: 'visible' }
        }
        {
          e: @$list.eq i
          p: { translateX: 20 }
          o: { duration: 100, easing: 'easeOutCubic', delay: 200, sequenceQueue: false }
        }
        {
          e: @$list.eq i
          p: { translateX: 0 }
          o: { duration: 100, easing: 'easeOutCubic' }
        }
      ]

    {
      first: [
        {
          e: @$heading
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block' }
        }
        {
          e: @$text
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', 300 ]
          o: { duration: 300, visibility: 'visible' }
        }
        {
          e: @$img
          p: { opacity: [ 1, 0 ] }
          o: { duration: 500, easing: 'easeOutSine', display: 'block' }
        }
      ]
      list1: listSequences[0]
      list2: listSequences[1]
      list3: listSequences[2]
      list4: listSequences[3]
      list5: listSequences[4]
      list6: listSequences[5]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/workflow-sequence.coffee